import { Injectable } from '@angular/core';
import { PageableUtilService } from '../util';
import { AssetFileListParams } from '@shared/models';
import { map, Observable, switchMap } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FilesService {

  private FILES_URL = '/api/assets/file';

  constructor(
    private util: PageableUtilService,
    private httpClient: HttpClient
  ) {}

  public assetDirectory(filters: AssetFileListParams): Observable<string[]> {
    const params = this.util.buildParams(null, filters);

    return this.httpClient.get<string[]>(`${this.FILES_URL}/list`, { params })
  }

  /** Stores a file and resolves to the name the server filed it under. */
  public upload(file: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', file);

    return this.httpClient
      .post<{ file: string }>(this.FILES_URL, formData)
      .pipe(map((r) => r.file));
  }

  /**
   * Uploads an image bundled with the app. The theme only ever references
   * stored files, so a bundled default has to be filed like any other upload
   * before it can be saved against the customer.
   */
  public uploadBundledAsset(path: string): Observable<string> {
    return this.httpClient
      .get(path, { responseType: 'blob' })
      .pipe(
        switchMap((blob) =>
          this.upload(
            new File([blob], path.split('/').pop(), { type: blob.type })
          )
        )
      );
  }

}
